<template>
  <div v-if="!featureData.activeObj.id" class="d-flex flex-column align-items-center gap-2 gap-md-3 mx-3 my-2 my-md-3">
    <input 
      ref="createTextInput" 
      class="form-control dl-panel-input-text" 
      type="text" 
      placeholder="點擊輸入文字" 
      v-model="designText" 
      maxlength="40"
      @focus="setFocusedInput"
      @blur="clearFocusedInput"
    />
    <div class="d-flex gap-2">
      <button class="mobile-upload-btn" @click="createText(designText, 'text')">新增水平文字</button>
      <button class="mobile-upload-btn" @click="createText(designText, 'vertical_text')">新增垂直文字</button>
    </div>
  </div>
  <div v-else style="height: 100%;">
    <div v-if="!isSubTitle" class="d-flex flex-column">
      <div class="dl-panel-item" >
        <input 
          class="form-control dl-panel-input-text" 
          type="text" 
          placeholder="點擊輸入文字" 
          v-model="selcetedDesignText" 
          style="border: 1px solid #000000;" 
          @input="changeText" 
          maxlength="40"
          @focus="setFocusedInput"
          @blur="clearFocusedInput"
        />
      </div>
      <div class="dl-panel-item">
        <span>文字方向</span>
        <div class="d-flex align-items-center gap-md-4 gap-1">
          <div class="dl-panel-item__box dl-panel-item__box--hover" @click="handleChangeDirection('text')">水平</div>
          <div class="dl-panel-item__box dl-panel-item__box--hover dl-panel-item__box--right-margin" @click="handleChangeDirection('vertical_text')">垂直</div>
        </div>
      </div>
      <div class="dl-panel-item" @click="updateTitle('修改字型')" style="cursor: pointer;">
        <span>Font</span>
        <div class="d-flex align-items-center" style="gap: 0.5rem">
          <img :src="currentFontFamily.image_url" alt="" style="max-height: 32px; max-width: 240px;">
          <img src="../../images/tools/goto_icon.png" alt="" width="15">
        </div>
      </div>
      <div class="dl-panel-item" @click="updateTitle('文字顏色')" style="cursor: pointer;">
        <span>Text Color</span>
        <div class="d-flex align-items-center" style="gap: 0.5rem">
          <div v-if="currentColor" class="color-box" :style="`background-color: ${currentColor};`"></div>
          <img src="../../images/tools/goto_icon.png" alt="" width="15">
        </div>
      </div>
      <div class="dl-panel-item">
        <span>常規定位</span>
        <div class="dl-panel-item__box dl-panel-item__box--hover dl-panel-item__box--right-margin" @click="handleAlignClick()">置中</div>
      </div>
      <div class="dl-panel-item">
        <span>規格</span>
        <div class="d-flex align-items-center gap-md-2 gap-1">
          <div class="d-flex align-items-center gap-2">
            寬度<input 
              class="dl-panel-item__box dl-panel-item__box--m-small" 
              inputmode="decimal"
              type="number" 
              step="0.1" 
              min="0" 
              v-model="featureData.activeObj.inputWidthCm"
              @focus="setFocusedInput"
              @blur="handleChangeSize('width', $event, true)"
              @keydown.enter="handleChangeSize('width', $event, false)"/>cm
          </div>
          <span style="font-size: 14px;">&ensp;x&ensp;</span>
          <div class="d-flex align-items-center gap-2">
            高度<input 
              class="dl-panel-item__box dl-panel-item__box--m-small" 
              inputmode="decimal"
              type="number" 
              step="0.1" 
              min="0" 
              v-model="featureData.activeObj.inputHeightCm"
              @focus="setFocusedInput"
              @blur="handleChangeSize('height', $event, true)"
              @keydown.enter="handleChangeSize('height', $event, false)"/>cm
          </div>
        </div>
      </div>
      <div v-if="isVerticalText(featureData.activeObj.design_type)" class="dl-panel-item">
        <span>間距</span>
        <input 
          class="dl-panel-item__box dl-panel-item__box--right-margin" 
          inputmode="decimal"
          type="number" 
          step="0.1" 
          min="0" 
          v-model="letterSpacingText"
          @focus="setFocusedInput"
          @blur="handleChangeLetterSpacing($event, true)"
          @keydown.enter="handleChangeLetterSpacing($event, false)"
        />
      </div>
    </div>
    <div v-else-if="featureData.panelTitle == '修改字型'" style="position: relative; height: 100%;">
      <div class="dl-panel-item">
        <input class="form-control" type="text" v-model="searchFilter" placeholder="輸入文字搜尋字體">
      </div>
      <div class="font-family-block">
        <div class="font-family-box" v-for="font in filterFontFamilys" :key="font.name" @click="changeFontFamily(font.value)">
          <div class="font-family-image">
            <img :src="`/api/designs/text?color=%230000ff&font_family=${font.value}&text=${encodeURIComponent(selcetedDesignText)}&height=40&limit_len=15`" loading="lazy">
          </div>
          {{ font.name }}
        </div>
      </div>
    </div>
    <div v-else-if="featureData.panelTitle == '文字顏色'">
      <div class="color-panel">
        <div class="color-selected">
          <span>顏色：</span>
          <div class="color-box" :style="`background-color: ${currentColor};`"></div>
        </div>
        <div class="color-block">
          <div class="color-box" v-for="color in textInfo.font_colors" :key="color.name" :style="`background-color: ${color.code};`" @click="changColor(color.code)"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, watch, computed, reactive } from 'vue'
import { features, maxWidth, isTextType, isVerticalText, getTextImage, getVerticalTextImage, featureData, setFeatureData, handleAlignClick, changeTextSize, changeTextDirection, changeVerticalTextLetterSpacing, setFocusedInput, clearFocusedInput } from "~/vues/utils/feature.js"

import {useDesignLabStore} from "../components/DesignLabStore.js"
import {storeToRefs} from 'pinia'
import {Debounce} from "~/javascripts/common.js";

const designLabStore = useDesignLabStore();
const { textInfo } = storeToRefs(designLabStore);

const designText = ref('')
const selcetedDesignText = ref('')
const createTextInput = ref()
const currentFontFamily = computed(() => textInfo.value.font_familys.find(x => x.value == featureData.activeObj.font_family))
const currentColor = ref('')
const letterSpacingText = ref(null)
const searchFilter = ref('')
const LANGUAGE_MAP = {
  chinese: {
    label: '中文',
    regex: /[\u4E00-\u9FFF\u3400-\u4DBF\uF900-\uFAFF]/,
    fontFlag: "is_chinese"
  },
  english: {
    label: '英文',
    regex: /[A-Za-z]/,
    fontFlag: "is_english"
  },
  japanese: {
    regex: /[\u3040-\u309F\u30A0-\u30FF\u31F0-\u31FF]/,
    fontFlag: "is_japanese"
  },
}
const FULLWIDTH_REGEX = /[\u3000-\u303F\uFF00-\uFFEF]/
const EXTRA_ALLOWED = [
  '0-9',        // 數字
  ' ',          // 空白
  ',',          // ,
  '\\.',        // .
  '!',          // !
  '\\?',        // ?
  ':',          // :
  ';',          // ;
  "'",          // '
  '"',          // "
  '\\-',        // -
  '_',          // _
  '\\(',        // (
  '\\)',        // )
  '\\[',        // [
  '\\]',        // ]
].join('')
const ALLOWED_PATTERNS = Object.values(LANGUAGE_MAP)
  // 去掉 regex.source 外層的 []
  .map(lang => lang.regex.source.replace(/^\[(.*)\]$/, '$1'))

ALLOWED_PATTERNS.push(EXTRA_ALLOWED)

// 建立乾淨正則（不會有雙層 []）
const ALLOWED_REGEX = new RegExp(`^[${ALLOWED_PATTERNS.join('')}]+$`, 'u')
const NOT_ALLOWED_REGEX = new RegExp(`[^${ALLOWED_PATTERNS.join('')}]`, 'gu')

const isSubTitle = computed(() => {
  return !features.map(x => x.name).includes(featureData.panelTitle)
})

const filterFontFamilys = computed(() => {
  const searchText = searchFilter.value.trim().toLowerCase();
  const selectedText = selcetedDesignText.value;

  if (FULLWIDTH_REGEX.test(selectedText)) return []

  if (!ALLOWED_REGEX.test(selectedText)) return []

  const langs = Object.keys(LANGUAGE_MAP).filter(langKey =>
    LANGUAGE_MAP[langKey].regex.test(selectedText)
  )

  return textInfo.value.font_familys.filter(fontFamily => {
    // 搜尋比對
    const matchSearch = fontFamily.name.toLowerCase().includes(searchText)
    if (!matchSearch) return false

    // 語言對應字型判斷：字型必須支援全部語言才通過
    return langs.every(langKey => fontFamily[LANGUAGE_MAP[langKey].fontFlag] === true)
  })
})

const normalizeLetterSpacing = (value) => {
  const rawValue = parseFloat(value)
  const safeValue = Number.isFinite(rawValue) ? rawValue : 0
  const clampedValue = Math.min(Math.max(safeValue, 0), 3.0)

  return Math.floor(clampedValue * 10) / 10
}

const formatLetterSpacing = (value) => {
  return normalizeLetterSpacing(value).toFixed(1)
}

const syncLetterSpacingText = () => {
  if (!isVerticalText(featureData.activeObj.design_type)) {
    letterSpacingText.value = null
    return;
  }

  letterSpacingText.value = formatLetterSpacing(featureData.activeObj.letter_spacing)
}


const createText = (text, designType) => {
  var defaultColor = textInfo.value.font_colors[textInfo.value.default_font_color_idx]?.code
  var defaultFontObj = textInfo.value.font_familys[textInfo.value.default_font_family_idx]
  var defaultFont = defaultFontObj?.value

 
  if (text && defaultColor && defaultFont ) {
    let validateErrorMessage = '';
    if (NOT_ALLOWED_REGEX.test(text)) {
      designText.value = designText.value.replace(NOT_ALLOWED_REGEX, '')
      validateErrorMessage += '含有系統不支援的文字\n'
    }

    if (FULLWIDTH_REGEX.test(text)) {
      designText.value = designText.value.replace(FULLWIDTH_REGEX, '')
      validateErrorMessage += '系統不支援全形文字\n'
    }

    const langs = Object.keys(LANGUAGE_MAP).filter(langKey =>
      LANGUAGE_MAP[langKey].regex.test(text)
    )

    for (const langKey of langs) {
      const flag = LANGUAGE_MAP[langKey].fontFlag
      if (!defaultFontObj[flag]) {
        // 移除該語言字元
        const regex = new RegExp(LANGUAGE_MAP[langKey].regex.source, 'g')
        designText.value = designText.value.replace(regex, '')
        validateErrorMessage += `該字型不支援 ${LANGUAGE_MAP[langKey].label} 文字\n`
      }
    }

    if (validateErrorMessage !== '') {
      alert(validateErrorMessage);
      return;
    }

    isVerticalText(designType) ?
      getVerticalTextImage(text, defaultColor, defaultFont) :
      getTextImage(text, defaultColor, defaultFont);

    designText.value = ''
  }
}

const init = () => {
  if (createTextInput.value) {
    createTextInput.value.focus()
  }
  if (featureData.activeObj.id && isTextType(featureData.activeObj.design_type)) {
    selcetedDesignText.value = featureData.activeObj.text
    // currentFontFamily.value = featureData.activeObj.font_family
    currentColor.value = featureData.activeObj.textColor
    syncLetterSpacingText();
  }
}

//當文字內容改變後，需重取一次圖
const changeText = Debounce(() => {
  if (selcetedDesignText.value && featureData.activeObj.id) {
    let validateErrorMessage = ''
    if (NOT_ALLOWED_REGEX.test(selcetedDesignText.value)) {
      selcetedDesignText.value = selcetedDesignText.value.replace(NOT_ALLOWED_REGEX, '')
      validateErrorMessage += '含有系統不支援的文字\n'
    }

    if (FULLWIDTH_REGEX.test(selcetedDesignText.value)) {
      selcetedDesignText.value = selcetedDesignText.value.replace(FULLWIDTH_REGEX, '')
      validateErrorMessage += '系統不支援全形文字\n'
    }

    const langs = Object.keys(LANGUAGE_MAP).filter(langKey =>
      LANGUAGE_MAP[langKey].regex.test(selcetedDesignText.value)
    )

    for (const langKey of langs) {
      const flag = LANGUAGE_MAP[langKey].fontFlag
      if (!currentFontFamily.value[flag]) {
        // 移除該語言字元
        const regex = new RegExp(LANGUAGE_MAP[langKey].regex.source, 'g')
        selcetedDesignText.value = selcetedDesignText.value.replace(regex, '')
        validateErrorMessage += `該字型不支援 ${LANGUAGE_MAP[langKey].label} 文字\n`
      }
    }

    if (validateErrorMessage !== '') {
      alert(validateErrorMessage);
      return;
    }

    isVerticalText(featureData.activeObj.design_type) ?
      getVerticalTextImage(selcetedDesignText.value, currentColor.value, currentFontFamily.value.value, featureData.activeObj.angle, featureData.activeObj.imageWidth, featureData.activeObj.letter_spacing):
      getTextImage(selcetedDesignText.value, currentColor.value, currentFontFamily.value.value, featureData.activeObj.angle, featureData.activeObj.imageHeight);
  }
},300)

const changeFontFamily = (value) => {
  featureData.activeObj.font_family = value
  isVerticalText(featureData.activeObj.design_type) ?
    getVerticalTextImage(selcetedDesignText.value, currentColor.value, currentFontFamily.value.value, featureData.activeObj.angle, featureData.activeObj.imageWidth, featureData.activeObj.letter_spacing):
    getTextImage(selcetedDesignText.value, currentColor.value, currentFontFamily.value.value, featureData.activeObj.angle, featureData.activeObj.imageHeight);
}

const changColor = (color) => {
  currentColor.value = color
  isVerticalText(featureData.activeObj.design_type) ?
    getVerticalTextImage(selcetedDesignText.value, currentColor.value, currentFontFamily.value.value, featureData.activeObj.angle, featureData.activeObj.imageWidth, featureData.activeObj.letter_spacing):
    getTextImage(selcetedDesignText.value, currentColor.value, currentFontFamily.value.value, featureData.activeObj.angle, featureData.activeObj.imageHeight);
}

const updateTitle = (title) => {
  setFeatureData('panelTitle', title)
}

const handleChangeSize = (side, event, isClear = false) => {
  const value = (Math.floor(event.target.value * 10) / 10); // 這邊輸入的值無條件捨去到小數第一位
  if(isClear) clearFocusedInput(event);

  if(!isTextType(featureData.activeObj.design_type)) return;
  
  changeTextSize(side, value, selcetedDesignText.value, currentColor.value, currentFontFamily.value.value, isVerticalText(featureData.activeObj.design_type));
}

const handleChangeDirection = (designType) => {
  if(featureData.activeObj.design_type === designType) return;

  isVerticalText(designType) ?
    letterSpacingText.value = "0.0" :
    letterSpacingText.value = null;
  
  changeTextDirection(designType, selcetedDesignText.value, currentColor.value, currentFontFamily.value.value, );
}

const handleChangeLetterSpacing = (event, isClear = false) => {
  const value = normalizeLetterSpacing(event.target.value)
  const displayValue = value.toFixed(1)

  letterSpacingText.value = displayValue;
  if(isClear) clearFocusedInput(event);

  if(!isVerticalText(featureData.activeObj.design_type)) return
  
  changeVerticalTextLetterSpacing(selcetedDesignText.value, currentColor.value, currentFontFamily.value.value, featureData.activeObj.angle, featureData.activeObj.imageWidth, value)
}

onMounted(() => {
  init()
})

watch(() => featureData.activeObj.id, (n) => {
    if (n && isTextType(featureData.activeObj.design_type)) {
      selcetedDesignText.value = featureData.activeObj.text
      // currentFontFamily.value = featureData.activeObj.font_family
      currentColor.value = featureData.activeObj.textColor

      syncLetterSpacingText();
    }
}, {deep: true})

//當文字顏色改變後，需重取一次圖，僅在選擇顏色的地方，才須重取圖，watch改變的值不可重取圖
// watch(currentColor, (n, o) => {
//   if (n && o && featureData.panelTitle == '文字顏色') {
//     getTextImage(selcetedDesignText.value, currentColor, currentFontFamily.value, featureData.activeObj.angle, featureData.activeObj.imageHeight)
//   }
// })
// //當文字字型改變後，需重取一次圖，僅在選擇字型的地方，才須重取圖，watch改變的值不可重取圖
// watch(() => currentFontFamily.value, (n, o) => {
//   if (n && o && featureData.panelTitle == '修改字型') {
//     getTextImage(selcetedDesignText.value, currentColor, currentFontFamily.value, featureData.activeObj.angle, featureData.activeObj.imageHeight)
//   }
// })

</script>
